
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage"; // @ is an alias to /src
import AppUtil from "@/util/AppUtil";
import UserVo from "@/vo/UserVo";
import { Grid, GridItem, Popup } from "vant";
@Options({
  components: {
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
})
/**超级会员首页 */
export default class ShareholderIndex extends BasePage {
  data = { creatDate: "", bonusEndDate: "" };
  
  user: UserVo = UserVo.getInstance();
  config = {
    tgArr: [
      {
        icon: require("@/assets/icon/yj.png"),
        text: "我的佣金",
        url: "/shareholder/commission",
      },
      {
        icon: require("@/assets/icon/txjl.png"),
        text: "提现记录",
        url: "/store/txList",
        query: { type: 2 },
      },
      {
        icon: require("@/assets/icon/kh.png"),
        text: "我的客户",
        url: "/staff/members",
      },
      {
        icon: require("@/assets/icon/qr.png"),
        text: "我的名片",
        url: "showQr",
      },
    ],
    comArr: [
      {
        icon: require("@/assets/icon/hxrz.png"),
        text: "我的股本",
        url: "/#/shareholder/capital",
      },
      {
        icon: require("@/assets/icon/hxygl.png"),
        text: "贵宾卡",
        url: "/#/shareholder/Packages",
      },
      {
        icon: require("@/assets/icon/sysm.png"),
        text: "使用说明",
        url: "/#/web?type=2"
      },
      {
        icon: require("@/assets/icon/gdgj.png"),
        text: "超级会员管家",
        url: "/#/shareholder/keeper",
      },
    ],
    /**显示名片弹窗 */
    showQr: false,
  };
  _title = "超级会员中心";

  mounted() {
    if (!this.user.id) {
      this.user.req_data();
    }
    AppUtil.request(
      { url: "/zhShareholder/shareholder/getShareholderInfo", method: "POST" },
      this.get_info_ok
    );
    // this.user=
  }
  get_info_ok(res: any) {
    // console.log("超级会员数据", res);
    // res.data.thumb = AppUtil.get_thumb(res.data.storeLogo);
    res.data.creatDate=res.data.creatDate.split(" ")[0];
    res.data.bonusEndDate=res.data.bonusEndDate.split(" ")[0];
    this.data = res.data;
    this.appVo.shareholder= res.data;
    // this.config.comArr[1].url="/#/store/clerks?id="+res.data.id;
    // StoreIndex.serveArr=res.data.serveJson||[];
  }

  /**推广中心点击事件 */
  tg_click(item: any) {
    console.log("item", item);
    if (item.url == "showQr") {
      //显示推广二维码
      return this.show_qr();
    }
    this.$router.push({
      path: item.url,
      query: item.query,
    });
  }
  /**显示名片弹窗 */
  private show_qr() {
    if (this.user.tgQrUrl) {
      return (this.config.showQr = true);
    }
    AppUtil.request(
      { url: "/zhMember/member/getMemberQRCode", method: "POST" },
      (res: any) => {
        console.log("名片", res);
        this.user.tgQrUrl = res.data;
        this.config.showQr = true;
      },
      "正在生成名片..."
    );
  }
}
